import { QueryClient } from "@tanstack/react-query";

/**
 * app/admin 공통 QueryClient 팩토리.
 *
 * - staleTime 30s: 화면 재진입/리마운트 시 즉시 재요청하지 않음(과도한 네트워크 방지)
 * - refetchOnWindowFocus false: 관제 화면 특성상 포커스 전환마다 재요청은 불필요
 * - retry 1: 일시적 네트워크 오류만 1회 재시도(무한 재시도로 인한 부하 방지)
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}
